const breakpoints = {
    desktop: 1280,
    largeTablet: 1024,
    tablet: 768,
    mobile: 600
};

export { breakpoints };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zZXJ2ZXItY29tcG9uZW50cy9sYXlvdXQvY29uc3RhbnRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBicmVha3BvaW50cyA9IHtcbiAgZGVza3RvcDogMTI4MCxcbiAgbGFyZ2VUYWJsZXQ6IDEwMjQsXG4gIHRhYmxldDogNzY4LFxuICBtb2JpbGU6IDYwMFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBYSxNQUFBLFdBQVcsR0FBRztBQUN6QixJQUFBLE9BQU8sRUFBRSxJQUFJO0FBQ2IsSUFBQSxXQUFXLEVBQUUsSUFBSTtBQUNqQixJQUFBLE1BQU0sRUFBRSxHQUFHO0FBQ1gsSUFBQSxNQUFNLEVBQUUsR0FBRzs7Ozs7In0=
